import { defineStore } from 'pinia'
import axios from 'axios'

export const useConfigStore = defineStore('config', {
  state: () => ({
    env: null,
    loaded: false,
  }),

  getters: {
    isProduction: (state) => state.env === 'production',
    envName: (state) => state.env || 'development',
    envPrefix: (state) => {
      if (state.env === 'production') return ''
      const shortNames = {
        development: 'DEV',
        staging: 'STAGING',
        local: 'LOCAL',
        testing: 'TEST',
      }
      const name = shortNames[state.env] || state.env?.toUpperCase() || 'DEV'
      return `[${name}] `
    },
  },

  actions: {
    async loadConfig() {
      if (this.loaded) return
      try {
        const { data } = await axios.get('/api/config')
        this.env = data.env
      } catch (error) {
        this.env = 'production' // Fallback sécurisé
      }
      this.loaded = true
    },
  },
})
